import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import Image from "components/image";

// Images
import dum3 from "img/dumerils/2020-07-28 11.41.13.jpg";
import dum8 from "img/dumerils/20200811-DSC_8467.jpg";
import collectionMeta from "content/collections/dumerils-boa.json";
import { animalGridFromJson } from "hooks/useGallery";
// Bear
// Cuddles
// Moose
// Snuggles

// Wiggles

const animalGridData = animalGridFromJson(collectionMeta);

const DumerilsBoa = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Dumeril's Boas (Acrantophis dumerili)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/dumerils-boa" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        In the late 1990s when I was getting into the adult phase of my reptile
        keeping I met friends nearby who shared my reptile keeping passion, and
        after a couple years of talking about it we went to our first big
        reptile show in San Diego California in the summer of 2000. It was quite
        the road trip. Obviously we talked reptiles for the entire 12 hour drive
        down and back, and while we were there we saw animals I had never seen
        before in real life. Of course, I couldn't make such a long trip and
        come home empty-handed so I picked up a pair of blood pythons and a pair
        of Dumerils boas.
      </BodyText>
      <BodyText>
        The Dumerils impressed me because they had an intricate, high-contrast
        pattern that looked like nothing I had ever seen.
      </BodyText>
      <Image src={dum8} caption="2020 litter of Dumeril's boas" />
      <BodyText>
        It's funny that by the mid 2000's I had lost track of which Dumeril's
        was the male and which was the female. I paired the two together for my
        first attempt at breeding them in 2007 and when the babies were born,
        both parents were still in the cage. So I still didn't know which was
        which. Finally, they bred again in 2010 and the babies were born when
        the parents were separated. I made sure to do a better job keeping track
        after that.
      </BodyText>
      <Image
        src={dum3}
        caption="2020, escapee baby that I found in a notebook on my shelf"
      />
      <BodyText>
        Another funny thing with my Dumeril's is that when I kept them in cages
        with sliding glass doors the doors weren't always closed tightly the
        night when babies were being born, so sometimes I'd come in and there
        would be a few babies in the cage with mom, and then signs on the floor
        that there were more babies roaming around. We've had to do full
        searches of our basement trying to see what we can find. One time I
        found a baby when I pulled a notebook down from a shelf and opened it
        up and there was a baby in between the rings.
      </BodyText>

      <PageGallery slug="dumerils-boa" maxWidth="900" />

    </ContentBox>
  );
};

export default DumerilsBoa;
